const currencyCookieKey = 'user-currency'

export const useCurrency = () => {
  const { locale } = useLocale()

  const cookie = useCookie(currencyCookieKey, {
    // startsWith: locale může být dlouhý (en_GB) i krátký/BE formát (en)
    default: () => (locale.value?.startsWith('en') ? 'EUR' : 'CZK'),
  })
  const currency = useState('currency', () => cookie.value)

  watch(
    currency,
    () => {
      cookie.value = currency.value
    },
    { deep: true }
  )

  const changeCurrency = (c: string) => {
    currency.value = c
  }

  return {
    currency,
    changeCurrency,
  }
}
